import { render, staticRenderFns } from "./ThgQuickCheckoutValidateRegistrationCard.vue?vue&type=template&id=66238e9c"
import script from "./ThgQuickCheckoutValidateRegistrationCard.vue?vue&type=script&lang=ts"
export * from "./ThgQuickCheckoutValidateRegistrationCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports